import { GamePlay } from "../model/game-play"
import { Command } from "./Command"

export class CopyPenaltyYardsKickoffCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private nextGamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND CopyPenaltyYardsKickoffCommand', this.gamePlay)

    this.nextGamePlay.penYardsKickoff = this.gamePlay.penYardsKickoff
  }
}
